import React, { createContext, useState, useEffect, useContext } from "react";

const MsisdnContext = createContext();

export const MsisdnProvider = ({ children }) => {
  const [msisdn, setMsisdn] = useState("");
  const [otp_, setOtp_] = useState("");
  const [msisdnBalance, setMsisdnBalance] = useState("____");

  useEffect(() => {
    // TODO: fetch msisdn balance
    setMsisdnBalance("____");
  }, []);

  return (
    <MsisdnContext.Provider
      value={{ msisdn, setMsisdn, otp_, setOtp_, msisdnBalance }}
    >
      {children}
    </MsisdnContext.Provider>
  );
};

export const useMsisdnContext = () => useContext(MsisdnContext);

export default MsisdnContext;
